import React, { useState, useEffect, useRef } from "react";
import {
  FaCrown,
  FaShieldAlt,
  FaHeart,
  FaGlobe,
  FaStar,
  FaGift,
  FaArrowRight,
  FaPlay,
} from "react-icons/fa";
import "../Vender/css/MemberShipBenifit.css";

const MemberShipBenifit = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeCard, setActiveCard] = useState(null);
  const sectionRef = useRef(null);

  const benefits = [
    {
      icon: <FaGlobe />,
      title: "Global Access",
      desc: "250+ resorts in 25+ countries",
      color: "#6366f1",
    },
    {
      icon: <FaGift />,
      title: "Gift Holidays",
      desc: "Share memorable experiences",
      color: "#8b5cf6",
    },
    {
      icon: <FaShieldAlt />,
      title: "Hassle-Free",
      desc: "We handle everything",
      color: "#06b6d4",
    },
    {
      icon: <FaCrown />,
      title: "5★ Luxury",
      desc: "Premium stays guaranteed",
      color: "#f59e0b",
    },
    {
      icon: <FaStar />,
      title: "Prime Spots",
      desc: "Best locations worldwide",
      color: "#10b981",
    },
    {
      icon: <FaHeart />,
      title: "Your Choice",
      desc: "Endless experiences await",
      color: "#ec4899",
    },
  ];

  const stats = [
    { value: "250+", label: "Resorts" },
    { value: "25+", label: "Countries" },
    { value: "25+", label: "Years" },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={`membership-section ${isVisible ? "is-visible" : ""}`}
      ref={sectionRef}
    >
      {/* Animated Background */}
      <div className="membership-bg">
        <div className="bg-gradient"></div>
        <div className="bg-pattern"></div>
        <div className="floating-shapes">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div className="membership-wrapper">
        {/* Header Section */}
        <div className="membership-header">
          <div className="header-badge">
            <span className="badge-dot"></span>
            <span>Membership Benefits</span>
          </div>
          <h2 className="header-title">
            Unlock a World of
            <span className="title-highlight"> Luxury Holidays</span>
          </h2>
          <p className="header-subtitle">
            Join AACORE HOLIDAYS and enjoy premium resorts, exclusive
            destinations, and unforgettable experiences.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="benefits-grid">
          {benefits.map((item, index) => (
            <div
              key={index}
              className={`benefit-card ${activeCard === index ? "active" : ""}`}
              style={{ "--delay": `${index * 0.1}s`, "--accent": item.color }}
              onMouseEnter={() => setActiveCard(index)}
              onMouseLeave={() => setActiveCard(null)}
            >
              <div className="card-glow"></div>
              <div className="card-content">
                <div className="card-icon-wrapper">
                  <div className="card-icon">{item.icon}</div>
                  <div className="icon-ring"></div>
                </div>
                <div className="card-info">
                  <h3 className="card-title">{item.title}</h3>
                  <p className="card-desc">{item.desc}</p>
                </div>
                <div className="card-arrow">
                  <FaArrowRight />
                </div>
              </div>
              <div className="card-border"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MemberShipBenifit;
